
/*
 *
 * ┌────────────────────────────────────────────────────────────────┐
 * │                                                                │
 * │                       ____                __                   │
 * │                      / __ \___  ___  ____/ /                   │
 * │                     / /_/ / _ \/ _ \/ __  /                    │
 * │                    / _, _/  __/  __/ /_/ /                     │
 * │                   /_/ |_|\___/\___/\__,_/                      │
 * │                                                                │
 * │                                                                │
 * └────────────────────────────────────────────────────────────────┘
 *
 */




/*-----------------------------------------------------------------------------------*/
/*  00. COMPONENTS IMPORTS
/*-----------------------------------------------------------------------------------*/

import Vue from 'vue'
import { CSSPlugin } from 'gsap/all'

import Browser from './components/Browser'
import Router from './components/Router'
import Layout from './components/Layout'

import KioskApp from './kiosk/App.vue'


const treeShakingAvoided = [CSSPlugin]
const APP = window.APP || {}

// Global mixin for translation
const dataTranslationsJSON = document.getElementById('dataTranslationsJSON')
const dataTranslations = JSON.parse(dataTranslationsJSON.text)

Vue.mixin({
    data() {
        return {
            alltrans: dataTranslations,
            trans: dataTranslations.fr,
        }
    },
})



/*-----------------------------------------------------------------------------------*/
/*  01. INIT
/*-----------------------------------------------------------------------------------*/

const initApp = () => {
    window.APP = APP

    APP.Browser = new Browser()
    APP.Router  = new Router()
    APP.Layout  = new Layout()

    APP.Kiosk = new Vue({
        render: h => h(KioskApp),
    }).$mount('#app')
}

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    initApp()
} else {
    document.addEventListener('DOMContentLoaded', initApp)
}



